export type ChartToolbarHighlight = 'suspicious' | 'new' | 'repriced' | 'sellerType';

export const CHART_TOOLBAR_HIGHLIGHT_KEYS = [
  'suspicious',
  'new',
  'repriced',
  'sellerType',
] as const satisfies readonly ChartToolbarHighlight[];

export type ChartToolbarHighlights = Record<ChartToolbarHighlight, boolean>;

export const defaultChartToolbarHighlights: ChartToolbarHighlights = {
  suspicious: false,
  new: false,
  repriced: false,
  sellerType: false,
};
